import request from '@/utils/request'
function index(){
    return request({
        method:'get',
        url:'/home/content/52?type=0'
    })
}
function sign(url){
    return request({
        method:'get',
        url:`https://tech.3cink.com/yihuapay/wechat/sign?url=${url}`
    })
}
export {index,sign,token,ticket}


// WEBPACK FOOTER //
// ./src/api/index.js